<template>
  <div class="access-denied-container">
    <div class="access-denied-content">
      <!-- Shield Icon -->
      <div class="icon-wrapper">
        <div class="icon-bg">
          <v-icon size="80" color="error">mdi-shield-lock-outline</v-icon>
        </div>
      </div>

      <!-- Title -->
      <h2 class="error-title">Access Denied</h2>

      <!-- Description -->
      <p class="error-description">
        You don't have permission to access this page.<br />
        Please contact your administrator if you believe this is an error.
      </p>

      <!-- Footer info -->
      <p class="error-footer">
        <v-icon size="14" class="mr-1">mdi-information-outline</v-icon>
        If you need access, ask a Super Admin to update your Page Access permissions.
      </p>
    </div>

    <!-- Background decoration -->
    <div class="bg-decoration">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccessDenied',
};
</script>

<style scoped>
.access-denied-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e9f2 100%);
  position: relative;
  overflow: hidden;
}

.access-denied-content {
  text-align: center;
  z-index: 1;
  padding: 40px;
  max-width: 540px;
}

.icon-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 24px;
}

.icon-bg {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: linear-gradient(135deg, #fff5f5 0%, #fee2e2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 8px 32px rgba(239, 68, 68, 0.15);
}

.error-title {
  font-size: 28px;
  font-weight: 600;
  color: #1e293b;
  margin: 8px 0 16px;
}

.error-description {
  font-size: 16px;
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 32px;
}

.error-footer {
  font-size: 13px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

/* Background decoration */
.bg-decoration {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.06;
}

.circle-1 {
  width: 400px;
  height: 400px;
  background: #ef4444;
  top: -100px;
  right: -100px;
}

.circle-2 {
  width: 300px;
  height: 300px;
  background: #3b82f6;
  bottom: -50px;
  left: -80px;
}

.circle-3 {
  width: 200px;
  height: 200px;
  background: #8b5cf6;
  bottom: 20%;
  right: 10%;
}
</style>